module.exports = __webpack_public_path__ + "static/media/ic-mekar.b31d24f7.svg";